import React, {Suspense} from 'react';
import {Switch} from 'react-router-dom';
import {ContentRoute, LayoutSplashScreen} from '../../../_metronic/layout';
import {TransfersByAgentPage} from './pages/TransfersByAgentPage';

export default function TransfersByAgent() {
  return (
    <Suspense fallback={<LayoutSplashScreen/>}>
      <Switch>
        <ContentRoute path="/transfersByAgent/:agentId" component={TransfersByAgentPage}/>
      </Switch>
    </Suspense>
  );
}
